import { render, staticRenderFns } from "./storeHours.vue?vue&type=template&id=f22de9f6&scoped=true&"
import script from "./storeHours.vue?vue&type=script&lang=js&"
export * from "./storeHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22de9f6",
  null
  
)

export default component.exports